import { makeStyles } from 'tss-react/mui';

export default makeStyles()((theme) => ({
  root: {},
  selectRoot: {
    backgroundColor: theme.palette.action.hover,
    borderRadius: 0,
    padding: 0,
  },
  selectInput: {
    padding: theme.spacing(2, 0, 2, 2),
    minHeight: 56,
  },
  dropdownArrow: {
    color: theme.palette.text.secondary,
  },
  dropdownContainer: {
    maxHeight: '250px',
    backgroundColor: theme.palette.background.paper,
  },
  inputLabelRoot: {
    fontFamily: 'Open Sans, sans-serif',
    fontWeight: 'bold',
    color: theme.palette.text.secondary,
    '&:focused': {
      color: theme.palette.text.primary,
    },
    fontSize: '0.825rem',
    marginBottom: theme.spacing(0.25),
  },
  anyWriterValue: {
    display: 'flex',
    alignItems: 'center',
    fontSize: '1em',
    paddingLeft: 0,
    paddingTop: theme.spacing(0.5),
    paddingBottom: theme.spacing(0.5),
  },
  selectedWriter: {
    display: 'flex',
    alignItems: 'center',
    paddingLeft: 0,
    paddingTop: theme.spacing(0.5),
    paddingBottom: theme.spacing(0.5),
  },
  avatarWrapper: {
    display: 'inline-flex',
    marginRight: theme.spacing(1),
    alignItems: 'center',
    '& > div': {
      display: 'inline-flex',
    },
  },
  listItemAvatar: {
    minWidth: theme.spacing(5),
    marginRight: theme.spacing(1),
    display: 'flex',
    alignItems: 'center',
    '& > div': {
      display: 'inline-flex',
    },
  },
}));
